import { Translation } from 'cng-common/features/translations/components/translation'
import { ITableColumn } from 'partner360/components/financialTable'
import { TRANSLATION_KEYS } from 'partner360/components/QBR/translations'
import { IQBRPlanAchievementDependOnSettings } from 'partner360/models/qbr/IQBRPlanAchievementDependOnSettings'

import { QbrQuarters } from '../../../../../../models/qbrQuarters'
import styles from '../PlanAchievement.module.scss'

import { getUnitsShortedViewCell } from './getUnitsShortedViewCell'

interface IGetColumnsUnitsShortedViewParameters {
  currentFYear: number
  selectedPeriodFQuarters: number[]
}
export const getColumnsUnitsShortedView = ({
  currentFYear,
  selectedPeriodFQuarters,
}: IGetColumnsUnitsShortedViewParameters): ITableColumn<IQBRPlanAchievementDependOnSettings>[] => {
  const previousFYear = currentFYear - 1
  const previousFYearLastTwoDigits = previousFYear.toString().slice(-2)

  const previousFYearColumns: ITableColumn<IQBRPlanAchievementDependOnSettings>[] = [
    {
      key: 'name',
      title: 'Name',
      renderFn: () => {
        return (
          <div className={styles.financialValueShortedView}>
            <p className={styles.paragraph}>
              <Translation span text={TRANSLATION_KEYS.financialTable.actual} />
            </p>
            <p className={styles.paragraph}>
              <Translation span text={TRANSLATION_KEYS.financialTable.plan} />
            </p>
            <p className={styles.paragraph}>
              <Translation span text={TRANSLATION_KEYS.financialTable.actToPlan} />
            </p>
            <p className={styles.paragraph}>
              <Translation span text={TRANSLATION_KEYS.financialTable.yoy} />
            </p>
          </div>
        )
      },
    },
    {
      key: `${previousFYear} Q1`,
      title: `Q1'${previousFYearLastTwoDigits}`,
      renderFn: (item) => {
        return getUnitsShortedViewCell({
          actualsUnits: item.PrevYearQ1ActualsUnits,
          plansUnits: item.PrevYearQ1PlansUnits,
          actualsToPlans: item.PrevYearQ1ActualsToPlansUnits,
          yoyActuals: item.PrevYearQ1YoYActualsUnits,
        })
      },
    },
    {
      key: `${previousFYear} Q2`,
      title: `Q2'${previousFYearLastTwoDigits}`,
      renderFn: (item) => {
        return getUnitsShortedViewCell({
          actualsUnits: item.PrevYearQ2ActualsUnits,
          plansUnits: item.PrevYearQ2PlansUnits,
          actualsToPlans: item.PrevYearQ2ActualsToPlansUnits,
          yoyActuals: item.PrevYearQ2YoYActualsUnits,
        })
      },
    },
    {
      key: `${previousFYear} Q3`,
      title: `Q3'${previousFYearLastTwoDigits}`,
      renderFn: (item) => {
        return getUnitsShortedViewCell({
          actualsUnits: item.PrevYearQ3ActualsUnits,
          plansUnits: item.PrevYearQ3PlansUnits,
          actualsToPlans: item.PrevYearQ3ActualsToPlansUnits,
          yoyActuals: item.PrevYearQ3YoYActualsUnits,
        })
      },
    },
    {
      key: `${previousFYear} Q4`,
      title: `Q4'${previousFYearLastTwoDigits}`,
      renderFn: (item) => {
        return getUnitsShortedViewCell({
          actualsUnits: item.PrevYearQ4ActualsUnits,
          plansUnits: item.PrevYearQ4PlansUnits,
          actualsToPlans: item.PrevYearQ4ActualsToPlansUnits,
          yoyActuals: item.PrevYearQ4YoYActualsUnits,
        })
      },
    },
  ]

  const currentFYearColumns: ITableColumn<IQBRPlanAchievementDependOnSettings>[] = []
  const currentFYearLastTwoDigits = currentFYear.toString().slice(-2)

  if (selectedPeriodFQuarters.includes(QbrQuarters.Q1)) {
    currentFYearColumns.push({
      key: `${currentFYear} Q1`,
      title: `Q1'${currentFYearLastTwoDigits}`,
      renderFn: (item) => {
        return getUnitsShortedViewCell({
          actualsUnits: item.CurrentYearQ1ActualsUnits,
          plansUnits: item.CurrentYearQ1PlansUnits,
          actualsToPlans: item.CurrentYearQ1ActualsToPlansUnits,
          yoyActuals: item.CurrentYearQ1YoYActualsUnits,
        })
      },
    })
  }

  if (selectedPeriodFQuarters.includes(QbrQuarters.Q2)) {
    currentFYearColumns.push({
      key: `${currentFYear} Q2`,
      title: `Q2'${currentFYearLastTwoDigits}`,
      renderFn: (item) => {
        return getUnitsShortedViewCell({
          actualsUnits: item.CurrentYearQ2ActualsUnits,
          plansUnits: item.CurrentYearQ2PlansUnits,
          actualsToPlans: item.CurrentYearQ2ActualsToPlansUnits,
          yoyActuals: item.CurrentYearQ2YoYActualsUnits,
        })
      },
    })
  }

  if (selectedPeriodFQuarters.includes(QbrQuarters.Q3)) {
    currentFYearColumns.push({
      key: `${currentFYear} Q3`,
      title: `Q3'${currentFYearLastTwoDigits}`,
      renderFn: (item) => {
        return getUnitsShortedViewCell({
          actualsUnits: item.CurrentYearQ3ActualsUnits,
          plansUnits: item.CurrentYearQ3PlansUnits,
          actualsToPlans: item.CurrentYearQ3ActualsToPlansUnits,
          yoyActuals: item.CurrentYearQ3YoYActualsUnits,
        })
      },
    })
  }

  if (selectedPeriodFQuarters.includes(QbrQuarters.Q4)) {
    currentFYearColumns.push({
      key: `${currentFYear} Q4`,
      title: `Q4'${currentFYearLastTwoDigits}`,
      renderFn: (item) => {
        return getUnitsShortedViewCell({
          actualsUnits: item.CurrentYearQ4ActualsUnits,
          plansUnits: item.CurrentYearQ4PlansUnits,
          actualsToPlans: item.CurrentYearQ4ActualsToPlansUnits,
          yoyActuals: item.CurrentYearQ4YoYActualsUnits,
        })
      },
    })
  }

  return [...previousFYearColumns, ...currentFYearColumns]
}
